import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Loader from '../Loader'
import {handleConfirm, confirmLoadStateSelector, confirmClear, confirmFail} from '../../../modules/profile'
import {translationsLocaleSelector} from "../../../modules/app"
import queryString from 'query-string'
import WrappedIntlComponent from '../intl/WrappedIntlComponent'
import Auth from '.'
import { Redirect } from 'react-router-dom';

class HandleConfirm extends Component{
    render() {
        let {loaded, loading, error, formatMessage} = this.props;

        if(error){
            return <Redirect to="/404" />
        }

        return (
            <Auth>
                <h1 className="h2 text-center">{formatMessage('signUpConfirm')}</h1>
                {
                    (!loaded && loading) && <Loader/>
                }
            </Auth>
        )
    }

    componentDidMount() {
        let {handleConfirm, id, token, confirmFail, formatMessage, location : {search}} = this.props;
        let query = queryString.parse(search);

        id = query.id || id;
        token = query.key || token;

        if (!id || !token) {
            confirmFail({error : formatMessage("idAndKeyGetParamsAreRequired")})
            return
        }
        handleConfirm({id, token})
    }

    componentWillUnmount() {
        let {confirmClear} = this.props
        confirmClear()
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default WrappedIntlComponent(connect(
    state => {
        let {loaded, loading, error} = confirmLoadStateSelector(state)
        return {
            loaded,
            loading,
            error,
            locale : translationsLocaleSelector(state),
        }
    },
    {handleConfirm, confirmClear, confirmFail},
    null,
    {pure: false}
)(HandleConfirm))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/HandleConfirm.js